export default __webpack_public_path__ + "static/china-flag-fd8325d147b9f0aa560fa5d3f34f7a1f.svg";